import React from 'react'

function TagIcon(props) {
  const { tag, tagIcon, className = '' } = props

  const isSvg = tagIcon?.type === 'svg'

  return (
    <div className={`tag tag--icon mb-2 ${className}`}>
      {tagIcon && <div className="tag__icon mr-2">{isSvg ? tagIcon : <img src={tagIcon.url} alt={tagIcon.alt} />}</div>}
      {tag}
    </div>
  )
}

export default TagIcon
